import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { SearchTermsTable2 } from '../components/SearchTermsTable2'
import { TableStore } from '../components/table2/table_store'
import { useSavedFiltersStore } from '../hooks/useSavedFiltersStore'
import { useUser } from '../hooks/useUser'
import { useTableHooksFromStore } from '../packages/blueprint-components/src/useTableHooks'
import { userStore } from '../stores/user_store'
import { adManagerPerformanceGet } from '../util/adManagerPerformanceApi'

export const SearchTerms = observer(() => {
    const { profile } = useUser()

    const savedFiltersStore = useSavedFiltersStore()

    const [store] = useState<TableStore<any>>(new TableStore<any>(userStore, 'search_terms'))

    const load = (params) => {
        if (!profile) {
            return Promise.resolve()
        }

        const request = adManagerPerformanceGet('api/v5/search-terms', params, true)

        return request
            .then((res) => {
                // This is a custom mutator. We are basically taking the performance models
                // and flattening them out, so we have a single array with the top level
                // search terms and their children keywords or targets underneath
                const output = []

                res.data.data.forEach((searchTerm) => {
                    output.push({
                        ...searchTerm,
                        type_of: 'search_term',
                        original_type: searchTerm.type_of,
                    })

                    searchTerm?.performances?.forEach((item) => {
                        item.select_key = item.type_of + '_' + item.ad_group_id
                        item.type_of = 'ad_group'
                        output.push(item)
                    })
                })
                res.data.data = output

                return res
            })
            .catch((err) => {
                console.error(err)
            })
    }

    const tableHooks = useTableHooksFromStore(load, {}, false, store)

    return (
        <SearchTermsTable2
            tableHooks={tableHooks}
            store={store}
            savedFiltersStore={savedFiltersStore}
        />
    )
})
